(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-overview.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-overview.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipOverview = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.tipset.templates.betslipoverview(data);
    },
    templateContext: function() {
      return {
        isReduceMode: svs.tipset.models.play.get('isReduceMode'),
        isSingleRow: svs.tipset.models.play.get('isSingleRow')
      };
    },
    regions: {
      matchlist: '#betslipMatchlist',
      systeminfo: '#betslipSysteminfo'
    },
    className: 'betslip-expanded',
    events: {
      'click @ui.closeBtn': 'hideOverviewFolder',
      'click .js-close-overview-folder': 'hideOverviewFolder'
    },
    ui: {
      closeBtn: '.js-close-overview-folder',
      selectedRows: '.js-selected-rows',
      possibleRows: '.js-possible-rows'
    },

    initialize: function() {
      var self = this;

      this.uid = svs.tipset.getUid();
      this.dimmer = this.dimmer || $('.tipset-betslipoverview-dimmer');
      this.dimmer.on('click', this.hideOverviewFolder.bind(this));
      this.handleReduceMode();
      this.listenTo(svs.tipset.models.play, 'change', function() {
        self.handleReduceMode();
        self.render();
      });
      this.listenTo(
        svs.tipset.models.reduceFreeContainer,
        'change:rows',
        this.handleReduceMode.bind(this)
      );
      if (svs.tipset.models.play.get('isReduceMode')) {
        this.listenTo(
          svs.tipset.collections.matchlist,
          'buttonBet',
          function() {
            self.handleReduceMode();
            self.render();
          }
        );
      }
    },
    onDomRefresh: function() {
      this.handleReduceMode();
    },

    handleReduceMode: function() {
      if (svs.tipset.models.play.get('isReduceMode')) {
        this.$el.addClass('is-reduce-mode');

        if (
          typeof this.ui.selectedRows === 'object' &&
          typeof this.ui.possibleRows === 'object'
        ) {
          this.ui.selectedRows.text(
            svs.tipset.models.reduceFreeContainer.get('rows')
          );
          this.ui.possibleRows.text(
            svs.tipset.collections.matchlist.getNrOfRows()
          );
        }
      } else {
        this.$el.removeClass('is-reduce-mode');
      }
    },
    onDestroy: function() {
      this.dispose();
      this.dimmer.off('click', this.hideOverviewFolder().bind(this));
    },
    hideOverviewFolder: function() {
      this.dimmer.removeClass('tipset-betslipoverview-dimmer-visible');
      this.$el.parent().removeClass('tipset-slider-folder-open');
      this.model.set('overviewOpen', false);
    },
    onRender: function() {
      var betslipMatchList, systemInfo;
      if (svs.tipset.models.play.get('isSingleRow')) {
        betslipMatchList = new svs.tipset.views.BetslipSingleboardsCoupon({
          model: svs.tipset.models.betslipFooter
        });
      } else {
        betslipMatchList = new svs.tipset.views.BetslipMatchlist({
          collection: new svs.tipset.collections.BetslipMatchlist()
        });
        systemInfo = new svs.tipset.views.BetslipSysteminfo({
          model: new svs.tipset.models.BetslipSysteminfo()
        });
      }
      this.getRegion('matchlist').show(betslipMatchList);
      if (systemInfo && !svs.tipset.models.play.get('isReduceMode')) {
        this.getRegion('systeminfo').show(systemInfo);
      }

      this.handleReduceMode();

      svs.tipset.calls.addCall('betslip-expanded ' + this.uid);
    }
  });
})(Backbone, _, svs);

 })(window);